

import React, { useContext, useState } from 'react';
import Tab from 'components/common/Tab';
import { constant } from 'constants/constant';
import { ButtonHeading, Heading } from 'components';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import WalletTransacrtion from './WalletTransacrtion';
import { Usabilty } from 'pages/Usablity';
import { ManageSubscription } from 'pages';
import './wallet.css'

const Wallet = () => {
    useDocumentTitle("Wallet | T360");
    const [activeTab, setActiveTab] = useState("wallet");
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const { mastersChild } = useContext(UserContext);
    const masterChildDriver = mastersChild?.find((i) => i?.label === "Wallet");

    const [filter, setFilter] = useState({
        search: '',
    });

    const tabProps = {
        tabList: constant.walletTabs,
        callBackTab: (e) => setActiveTab(e),
        activeTab: activeTab
    };

    const toggleOffcanvas = (data) => {
        setShowOffcanvas(data);
    };

     const renderContent = () => {
        switch (activeTab) {
            case "wallet":
                return <WalletTransacrtion />;
            case "usability":
                return <Usabilty />;
            case "manage":
                return <ManageSubscription />;
            case "billing":
                return <><div className='__payM_head'><h6>Billing History</h6></div></>;
            default:
                return null;
        }
    };


    return (
        <>

         <Heading title={"Payments"} />

            <div className='__payMentMain_bx'>
                <div className="__sidePayBar">
                    <ul className='__payList_bx'>
                        <li>
                            <button
                                className={activeTab === "wallet" ? "__payActive_btn" : ""}
                                onClick={() => setActiveTab("wallet")}
                            >
                                Wallet
                            </button>
                        </li>
                        <li>
                            <button
                                className={activeTab === "usability" ? "__payActive_btn" : ""}
                                onClick={() => setActiveTab("usability")}
                            >
                                Usability
                            </button>
                        </li>
                        <li>
                            <button
                                className={activeTab === "manage" ? "__payActive_btn" : ""}
                                onClick={() => setActiveTab("manage")}
                            >
                                Manage Subscription
                            </button>
                        </li>
                        <li>
                            <button
                                className={activeTab === "billing" ? "__payActive_btn" : ""}
                                onClick={() => setActiveTab("billing")}
                            >
                                Billing History
                            </button>
                        </li>
                    </ul>
                </div>
                <div className="__mainPayBar">
                    <div className='__payM_contentBx'>
                        {renderContent()}
                    </div>
                </div>
            </div>

                {/* <div className='__payM_head'><h6>Wallet</h6></div>

                <WalletTransacrtion /> */}


            {/* </div> */}
        </>
    );
}

export default Wallet;